module.exports = __webpack_public_path__ + "static/media/Logo_Gregg.ede03ca2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Logo_Gregg.svg
// module id = 51
// module chunks = 0